import classnames from 'classnames/bind'
import { useRef } from 'react'

import { useGetCustomerAddresses } from '@unlikelystudio/react-ecommerce-hooks'
import Slider from '@unlikelystudio/react-slider'

import AddressItem from '~/components/Account/Logged/AddressBook/AdressItem'
import LoadingSection from '~/components/Account/Logged/LoadingSection'
import SectionTitle, {
  SectionTitleProps,
} from '~/components/Account/Logged/SectionTitle'
import { RichTextBlock } from '~/components/UI/RichText'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type AddressBookProps = SectionTitleProps & {
  addressesAreLoading?: boolean
  addAddressTitle?: RichTextBlock
  updateAddressTitle?: RichTextBlock
}

function AddressBook({ className, title, ...titles }: AddressBookProps) {
  const { data, isLoading } = useGetCustomerAddresses()
  const { addresses } = data ?? {}

  const customSliderRef = useRef()

  return (
    <div className={cx(css.Addresses, className)}>
      <SectionTitle title={title} />
      {isLoading ? (
        <LoadingSection />
      ) : (
        <div className={cx(css.content)}>
          {addresses?.length === 0 && (
            <AddressItem
              className={cx(css.item, css.hideOnSmallScreen)}
              isAdd
              {...titles}
            />
          )}
          {addresses?.length > 0 && (
            <Slider
              className={cx(css.slider, css.hideOnSmallScreen)}
              snap={true}
              customSliderRef={customSliderRef}>
              <AddressItem className={cx(css.item)} isAdd {...titles} />
              {addresses?.map((item, key) => (
                <AddressItem
                  key={`item_${key}`}
                  className={cx(css.item)}
                  {...titles}
                  {...item}
                />
              ))}
            </Slider>
          )}
          <div className={cx(css.mobileCards, css.hideOnLargeScreen)}>
            <AddressItem className={cx(css.item)} isAdd {...titles} />
            {addresses?.length > 0 &&
              addresses?.map((item, key) => (
                <AddressItem
                  key={`item_${key}`}
                  className={cx(css.item)}
                  {...titles}
                  {...item}
                />
              ))}
          </div>
        </div>
      )}
    </div>
  )
}

AddressBook.defaultProps = {}

export default AddressBook
